


export function createPageUrl(pageName: string) {
    return '/' + pageName.toLowerCase().replace(/ /g, '-');
}

/**
 * Formats an address for display, handling both string and object formats
 * @param address - The address to format (string or object)
 * @param fallback - Text to show if no address is provided (default: '-')
 * @returns Formatted address string
 */
export function formatAddress(address: any, fallback: string = '-'): string {
    if (!address) return fallback;
    
    // Handle string addresses (backward compatibility)
    if (typeof address === 'string') {
        return address || fallback;
    }
    
    // Handle object addresses
    if (typeof address === 'object') {
        const parts = [];
        
        if (address.street) parts.push(address.street);
        if (address.city) parts.push(address.city);
        if (address.state) parts.push(address.state);
        if (address.postal_code) parts.push(address.postal_code);
        if (address.country) parts.push(address.country);
        
        return parts.length > 0 ? parts.join(', ') : fallback;
    }
    
    return fallback;
}